/**
 * Debug-overlay settings — the player-tunable "Show FPS & ping" toggle,
 * persisted to localStorage so it survives reloads. Off by default (it's a
 * diagnostic readout, not part of the normal HUD).
 *
 * Mirrors camera-settings.ts: a tiny state module the settings panel writes and
 * the FPS overlay reads. The overlay subscribes via onShowFpsChange so toggling
 * the checkbox shows/hides it immediately, with no cross-module refs.
 */
const STORAGE_KEY = "tribez.showFps";

let showFps = load();
const listeners = new Set<(on: boolean) => void>();

function load(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function getShowFps(): boolean {
  return showFps;
}

export function setShowFps(on: boolean): void {
  showFps = on;
  try {
    localStorage.setItem(STORAGE_KEY, on ? "1" : "0");
  } catch {
    /* private-mode / quota — keep the in-memory value, just don't persist. */
  }
  for (const l of listeners) l(on);
}

/** Subscribe to toggle changes (e.g. to show/hide the overlay element). */
export function onShowFpsChange(cb: (on: boolean) => void): void {
  listeners.add(cb);
}
